import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import Service from '../../../util/Service';

export default function KanbanNovoDialog(props) {
  const { open, setOpen } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const nome = formJson.nome;
    if (!nome) {
      alert('Informe um nome para o kanban');
      return;
    }
    console.log(nome);
    const path = location.pathname;
    console.log(path);
    const arr = path.split("\/")
    console.log(arr);

    const dado = {
      nome: nome,
      id: arr[3],
    }

    console.log(dado)

    Service.POST("/api/security/projeto/kanban", dado).then(r => {
      console.log(r);
      // handleClose();
      if( r.success){
        const path = location.pathname;
        console.log(path);
        navigate('/project/kanban/'+dado.id+"/" + r.id);
      }
    })
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Novo Kanban</DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        <DialogContentText>
          Informe o nome do novo kanban. O kanban será criado com colunas padrões e poderão ser modificadas na tela do kanban.
        </DialogContentText>
        <form onSubmit={handleSubmit}>
          <TextField
            autoFocus
            required
            margin="dense"
            id="nome"
            name="nome"
            label="Nome"
            fullWidth
            variant="standard"
          />
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button type="submit">Criar</Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}
